import React from 'react';
import './CookiePolicy.css';
import HomePageFooter from '../../Components/HomePageFooter/HomePageFooter';

const CookiePolicy = () => {

    return (
        <div className='TC1App'>
            <div className='TC1template'>
                <h1>Cookie Policy</h1>
                <br></br>
                <div>
                    In this Cookie Policy, references to “We”, “Us” or “Our” mean Duonut Inc, whose registered address is No.467/468, TUSKER WORKSPACE PRIVATE LIMITED, Shri Krishna Temple Road, Indiranagar, Bengaluru, Bengaluru Urban, Karnataka, 560038.
                </div>
                <br></br>
                <div>
                    We may, through the websites owned and operated by Us (“Website(s)”) place and access certain first-party cookies on your computer or device. Any user visiting Our Website(s) will receive cookies from Us, and the details of the cookies used are set out below.
                </div>


                <br></br>
                <br></br>
                <h2>1. WHAT ARE COOKIES?</h2>
                <br></br>
                <div>
                    A cookie is a small text file placed on your computer or device by Our Website when you visit certain parts of Our Website and/or when you use certain features of Our Website. Cookies set by the Website owner are called “first party cookies”. Cookies set by parties other than the Website owner are called “third party cookies”.
                </div>


                <br></br>
                <br></br>
                <h2>2. WHY DO WE USE COOKIES?</h2>
                <br></br>
                <div>
                    We use cookies to facilitate and improve your experience on Our Website(s).  More specifically, we use cookies to:
                </div>
                <br></br>
                <div>1.  Help remember and process your chosen plan.</div>
                <br></br>
                <div>2.  Understand and save your preferences for future visits.</div>
                <br></br>
                <div>3.  Compile aggregate data about site traffic and site interactions in order to offer better Website experiences and tools in the future. We may also use trusted third-party services that track this information on our behalf.
                </div>
                <br></br>
                <div>
                    Further to this, Our Website uses website analytics services.  Website analytics refers to a set of tools used to collect and analyze usage statistics, enabling Us to better understand how people use Our Website. These enable Us to improve Our Website and the products and services offered through it. You do not have to allow Us to use these cookies, as detailed below, however, while Our use of them does not pose any risk to your privacy or your safe use of Our Website, it does enable Us to continually improve Our Website, making it a better and more useful experience for you.
                </div>


                <br></br>
                <br></br>
                <h2>3. LIST OF COOKIES WE USE</h2>
                <br></br>
                <div>The cookies used by Us may be categorized as: </div>
                <br></br>
                <div>
                    1.  Essential Cookies: We set essential cookies that enable core functionality such as security, network management, and accessibility. You may not opt-out of these cookies. However, you may disable these by changing your browser settings, but this may affect how the Website functions.
                </div>
                <br></br>
                <div>
                    2.  Analytics, Customisation and Advertising Cookies: We set these cookies to help Us improve Our Website by collecting and reporting information on how you use it. The cookies collect information in a way that does not directly identify anyone.
                </div>
                <br></br>
                <div>
                    3.  Flash Cookies: Certain features of Our Service may use local stored objects (or Flash Cookies) to collect and store information about your preferences or your activity on Our Service. Flash Cookies are not managed by the same browser settings as those used for Browser Cookies. For more information on how you can delete Flash Cookies, please read "Where can I change the settings for disabling, or deleting local shared objects?" available at this link.
                </div>
                <br></br>
                <div>
                    4.  Web Beacons: Certain sections of Our Service and Our emails may contain small electronic files known as web beacons (also referred to as clear gifs, pixel tags, and single-pixel gifs) that permit Us, for example, to count users who have visited those pages or opened an email and for other related website statistics (for example, recording the popularity of a certain section and verifying system and server integrity).
                </div>
                <br></br>
                <div>
                    5.  "Persistent" or "Session" Cookies: Persistent Cookies remain on your personal computer or mobile device when you go offline, while Session Cookies are deleted as soon as you close your web browser.
                </div>

                <br></br>
                <br></br>
                <h2>4. HOW CAN YOU CONTROL COOKIES? </h2>
                <br></br>
                <div>
                    Usually, before any cookies are placed on your computer or device, you will be shown a prompt such as a pop-up or message bar requesting your consent to set those cookies that are not essential or strictly necessary. By giving your consent to the placing of these cookies you are enabling Us to provide the best possible experience and service to you. You may, if you wish, deny consent to the placing of such cookies; however certain features of Our Website may not function fully or as intended.
                </div>


                <br></br>
                <br></br>
                <h2>5. DO NOT TRACK</h2>
                <br></br>
                <div>
                    Some Internet browsers - like Internet Explorer, Firefox, and Safari - include the ability to transmit “Do Not Track” or “DNT” signals. Since uniform standards for “DNT” signals have not been adopted, Our Website does not currently process or respond to “DNT” signals. We take privacy and meaningful choice seriously and will make efforts to continue to monitor developments around DNT browser technology and the implementation of a standard. To learn more about “DNT”, please visit All About Do Not Track: <a href="https://allaboutdnt.com/">https://allaboutdnt.com/</a>
                </div>


                <br></br>
                <br></br>
                <h2>6. RESOURCES YOU MAY WANT TO REFER TO</h2>
                <br></br>
                <div>
                    To find out more about cookies, visit www.aboutcookies.org  or All About Cookies by TermsFeed.
                    Further to this, the links below are helpful if you want to learn about advertiser’s use of cookies:
                </div>
                <br></br>
                <li>Internet Advertising Bureau (US)</li>
                <li>Internet Advertising Bureau (EU)</li>
                <br></br>
                <div>
                    Below are a few references to some popular browser manufacturers and their help pages relating to cookie management in their respective products.
                </div>
                <br></br>
                <li>Google Chrome</li>
                <li>Internet Explorer</li>
                <li>Android Browser</li>
                <li>Safari (Desktop)</li>
                <li>Mozilla Firefox</li>
                <li>Safari (Mobile)</li>


                <br></br>
                <br></br>
                <h2>7. HOW OFTEN WILL WE UPDATE THIS COOKIE POLICY?</h2>
                <br></br>
                <div>
                    We may update this Cookie Policy from time to time to reflect, for example, changes to the cookies we use or for other operational, legal or regulatory reasons. Please revisit this Cookie Policy regularly to stay informed about our use of cookies and related technologies. The date at the bottom of this Cookie Policy indicates when it was last updated.
                </div>


                <br></br>
                <br></br>
                <h2>8. WHERE CAN YOU GET FURTHER INFORMATION?</h2>
                <br></br>
                <div>
                    If you have any questions about our use of cookies or other technologies, please email Us at hello@dynamitech.in
                </div>
                <br></br>
                <br></br>
                <br></br>
            </div>
            <HomePageFooter />

        </div>
    );

}

export default CookiePolicy;